import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Card from '../../Components/Card/Index.js'
import Popup from '../../Components/Popup/Index.js'
import Sidebar from '../../Components/Sidebar/Index.js'
import Navbar from '../../Components/Navbar/Index.js'
import ProfileTrigger from '../../Components/ProfileTrigger/Index.js'
import Loader from '../../Components/Loader/Index.js'
import LoaderInline from '../../Components/Loader/LoaderInline.js'
import { AddIcon } from '../../Svg/Index.js'
import { FETCH_FILTERED_WAZZUP, LOAD_MORE_FILTERED_WAZZUP } from '../../Actions/Wazzup'
import { GET_CURRENT_USER, GET_PROFILE_BY_ID } from '../../Actions/User'
import { SET_TYPE, SET_LIKES_POPUP_ACTIVE } from '../../Actions/Sidebar'
import { MERCURE_URL } from '../../config'
import ChatPopup from './ChatPopup.js'


class Filtered extends Component {

    state = {
        sharePopupActive: false,
        feedLoading: false,
        page: 1,
        isPaginating: false,
        likesPopupActive: false,
        theUser: {

        }
    }

    UNSAFE_componentWillMount() {
        const { user } = this.props;

        if(!user.token) {
            this.props.history.push('/')
        }
        this.props.actions.FETCH_FILTERED_WAZZUP(this.props.sidebar.profile_theirs_open ? this.props.sidebar.profile_theirs_open : this.props.user._id ).then(()=> {
            this.setState({
                feedLoading: false
            })
        })
    }

    componentDidMount() {
        const { wazzup } = this.props;

        document.querySelectorAll('.c-tab-container')[0].addEventListener('scroll', this.loadMoreWazzup);

        if(!wazzup.filtered_threads.length) {
            this.setState({
                feedLoading: true
            })
        }

        this.props.actions.GET_PROFILE_BY_ID(this.props.sidebar.profile_theirs_open ? this.props.sidebar.profile_theirs_open : this.props.user._id ).then(user => {
            setTimeout(() => {
                this.setState({theUser: user})
            }, 500)
        })

        this.eventSource = new EventSource(`${MERCURE_URL}?topic=https://jongenout.nl/wazzup/new`);
		this.eventSource.addEventListener('message', () => {
            this.props.actions.FETCH_FILTERED_WAZZUP(this.props.sidebar.profile_theirs_open ? this.props.sidebar.profile_theirs_open : this.props.user._id )
        })
    }

    componentWillUnmount() {
        document.querySelectorAll('.c-tab-container')[0].removeEventListener('scroll', this.loadMoreWazzup);
        if(this.eventSource) {
            this.eventSource.close();
        }
    }

    loadMoreWazzup = () => {
        let element = document.querySelectorAll('.c-tab-container')[0];

        if(element.clientHeight + element.scrollTop > (element.scrollHeight - 800) ) {
            if(this.props.wazzup.filtered_pagination.filtered_pagination_has_next_page  ) {
                if(!this.state.isPaginating) {
                    this.setState({ isPaginating: true, page: this.state.page+1 })
                    this.props.actions.LOAD_MORE_FILTERED_WAZZUP(this.props.sidebar.profile_theirs_open ? this.props.sidebar.profile_theirs_open : this.props.user._id, this.state.page).then(()=> {
                        this.setState({ isPaginating: false })
                    });
                }
            }
        }
    }


    openSharePopup = () => {
        this.setState({
            sharePopupActive: true
        });
        document.body.classList.add('is-blurred');

    }

    closeSharePopup = () => {
        this.setState({
            sharePopupActive: false
        });
        document.body.classList.remove('is-blurred');

    }

    closeLikesPopup = () => {
        this.setState({
            likesPopupActive: false
        });
        this.props.actions.SET_LIKES_POPUP_ACTIVE(false)
        document.body.classList.remove('is-blurred');

    }
    

    render() {
        const { user, wazzup, sidebar } = this.props;
        const { sharePopupActive, feedLoading, theUser } = this.state;
        
        return (
            <>
                <div>

                    <div className="o-filtered-container">
                        <div>
                            {
                                theUser._id && (
                                    <>
                                        {
                                            feedLoading && (
                                                <div className="c-general-loader">
                                                    <Loader />
                                                </div>
                                            )
                                        }

                                        

                                        <div className="c-feed">
                                            {
                                                wazzup.filtered_threads.map((item, i) => 
                                                    <Card 
                                                        key={`wazzup-wall-${i}`}
                                                        user={item.first_message.user}
                                                        author={item.first_message.user.display_name}
                                                        authorImage={item.first_message.user.avatar.user_avatar}
                                                        createdAt={item.first_message.created_at_for_humans}
                                                        body={item.first_message.body}
                                                        image={item.first_message.image}
                                                        messageCount={item.message_count}
                                                        uuid={item._uuid}
                                                        id={item._id}
                                                        type="wazzup"
                                                        pinned={item.is_pinned}
                                                        like_count={item.like_count}
                                                        showLikes={true}
                                                        asPopup={true}
                                                    />
                                                )
                                            }

                                            


                                            {
                                                this.state.isPaginating && (
                                                    <LoaderInline />
                                                )
                                            }

                                        </div>
                                    </>
                                )
                            }
                        </div>
                        {
                            sharePopupActive && (
                                <Popup closeSharePopup={this.closeSharePopup.bind(this)} author={user.avatar.user_avatar} />
                            )
                        }

                        {
                            (theUser._id && wazzup.filtered_threads.length < 1) && (
                                <div className="c-user__empty">
                                    Nog geen posts<br />
                                    🤐
                                </div>
                            )
                        }

                    </div>
                    
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        wazzup: state.filtered_wazzup,
        sidebar: state.sidebar,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({FETCH_FILTERED_WAZZUP, SET_TYPE, LOAD_MORE_FILTERED_WAZZUP, GET_CURRENT_USER, SET_LIKES_POPUP_ACTIVE, GET_PROFILE_BY_ID }, dispatch)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Filtered)